var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m501.07 41.81a7.99 7.99 0 0 0 -6.64-1.65l-157.67 31.53-157.79-63.12a8 8 0 0 0 -4.54-.41l-160 32a7.99 7.99 0 0 0 -6.43 7.84v416a7.992 7.992 0 0 0 9.57 7.84l157.67-31.53 157.79 63.12a8 8 0 0 0 2.97.57 7.606 7.606 0 0 0 1.57-.16l160-32a7.99 7.99 0 0 0 6.43-7.84v-416a7.984 7.984 0 0 0 -2.93-6.19zm-333.07 383.63-144 28.8v-399.68l144-28.8zm160 58.74-144-57.6v-398.76l144 57.6zm160-26.74-144 28.8v-399.68l144-28.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapThin);
export default __webpack_public_path__ + "static/media/map-thin.ba509c5e.svg";
export { ForwardRef as ReactComponent };